import script from "./FormLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormLeadPropertyComponent.vue?vue&type=script&setup=true&lang=js"

import "./FormLeadPropertyComponent.vue?vue&type=style&index=0&id=1be22193&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1be22193"]])

export default __exports__